(function componentForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'AllInclusivePropertySheetBuildPricing',
	};

	$(document).ready(function documentReady() {
		Adzuki.Form.registerForm(form);
	});

	form.load = function load($form)
	{
		var $num_categories = $('#allinclusivepropertysheetbuildpricing-number_categories');
		var $price_type     = $('#allinclusivepropertysheetbuildpricing-price_type');

		// handle price type field changing
		$price_type.change(function togglePriceData()
		{
			$('.price-data').toggleClass('hidden', !this.value.length);
			$('.price-field').toggleClass('disabled', !this.value.length);
			$('.price-field').attr('disabled', !this.value.length);

			// $('.price-field').val('');
			// priceRecalculate();

			if (this.value) {
				priceRecalculate();
			} else {
				$('.price-field').val('');
				priceRecalculate();
			}
		});

		// handle number of categories changing
		$num_categories.change(function toggleCategoryData()
		{
			var max_categories = $('#allinclusivepropertysheetbuildpricing-max_categories').val(),
			    i;

			$('.category-data').addClass('hidden');

			for (i = max_categories; i >= 1; i--) {
				$('.category-row-' + i).addClass('hidden');
			}

			if (this.value.length > 0) {
				$('.category-data').removeClass('hidden');

				for (i = this.value; i >= 1; i--) {
					$('.category-row-' + i).removeClass('hidden');
				}
			}

			// trigger logic to enable/disable price fields
			$price_type.trigger('change');
		});

		// "add description/disclaimer" links under category names
		$('.toggle-category-details').click(function toggleDetails(e)
		{
			var $self        = $(this),
			    category_row = $self.data('category-row'),
			    action       = $self.data('action'),
			    container    = $self.data('container'),
			    field_key    = (category_row - 1);

			e.preventDefault();

			if (action === 'add') {
				// show field
				// hide add link
				$('.add-' + container + '-' + category_row).addClass('hidden');

				$('.category-' + container + '-container-' + category_row).slideToggle("fast", function slideBabySlide() {
					// enable the field
					$('#allinclusivepropertysheetbuildpricing-category_' + container + '-' + field_key).prop('disabled', false);

					// show container
					$('.category-' + container + '-container-' + category_row).removeClass('hidden');

					// show remove link
					$('.remove-' + container + '-' + category_row).removeClass('hidden');
				});
			} else {
				// hide field
				// hide remove link
				$('.remove-' + container + '-' + category_row).addClass('hidden');

				$('.category-' + container + '-container-' + category_row).slideToggle("fast", function slideBabySlide() {
					// hide container
					$('.category-' + container + '-container-' + category_row).addClass('hidden');

					// show add link
					$('.add-' + container + '-' + category_row).removeClass('hidden');

					// disable the field
					$('#allinclusivepropertysheetbuildpricing-category_' + container + '-' + field_key).prop('disabled', true);
				});
			}
		});

		// recalculate any time a pricing field changes
		$('.price-field').change(function triggerPriceRecalculate() {
			priceRecalculate();
		});

		// handle category details link being click
		Adzuki.Editor('.category-descriptions', {
			height     : 150,
			content_css: $('.category-descriptions').data('content-css'),
		});

		Adzuki.Editor('.category-disclaimers', {
			height     : 50,
			content_css: $('.category-disclaimers').data('content-css'),
		});

		// show appropriate fields on load
		$num_categories.trigger('change');


		function priceRecalculate()
		{
			var num_categories = $num_categories.val();
			var selected_label = $('#allinclusivepropertysheetbuildpricing-price_type option:selected').text();
			var selected_val   = $('#allinclusivepropertysheetbuildpricing-price_type option:selected').val();
			var i, price, fees_expenses, taxes, total, label;

			// if select isnt available, check hidden
			if (!selected_val) {
				selected_val = $price_type.val();
			}

			for (i=1;i <= num_categories;i++) {
				price = parseFloat($('#allinclusivepropertysheetbuildpricing-price-' + (i -1)).val());

				if ($('#allinclusivepropertysheetbuildpricing-required_fees_expenses-'+ (i -1)).is(':disabled')) {
					fees_expenses = 0;
				} else {
					fees_expenses = parseFloat($('#allinclusivepropertysheetbuildpricing-required_fees_expenses-' + (i -1)).val()) || 0;
				}

				if ($('#allinclusivepropertysheetbuildpricing-taxes_fees-'+ (i -1)).is(':disabled')) {
					taxes = 0;
				} else {
					taxes = parseFloat($('#allinclusivepropertysheetbuildpricing-taxes_fees-' + (i -1)).val()) || 0;
				}

				total = accounting.formatMoney(price + fees_expenses + taxes);
				label = '<strong>Total:</strong> ' + total + ' ' + selected_label;

				if (selected_val.length > 0) {
					$('#calculated-value-' + i).html(label);
				} else {
					$('#calculated-value-' + i).html('');
				}
			}
		}
	};
}(jQuery, window.Adzuki || {}));
